export default "__VITE_ASSET__CRcrx95K__"